const Formal = () => {
  return (
    <>
      <p>
        Lucas Sanches Ferreira is Brazilian-American editor
        based in Los Angeles.
        <br /><br />
        His commercial credits include Apple, Nike, and Google,
        alongside editorial work for high-end fashion brands
        across multiple NYFW seasons.
        <br /><br />
        Raised between São Paulo and Miami and educated in
        New York City, his background spans design,
        post-production, and music — a mix that informs how
        he cuts: with rhythm, structure, and a sensibility
        for the story being told.
      </p>
    </>
  )
}

export { Formal }
